import * as React from 'react';

import { ECollapseBlockType } from '../../containers/CollapseContainer/tracking';
import { WithCollapse } from '../../containers/WithCollapse';
import { Children } from '../Children';
import { ElectronicTradeDisclaimer } from '../ElectronicTradeDisclaimer';
import { EncumbranceDisclaimer } from '../EncumbranceDisclaimer';
import { ZalogAuctionDisclaimer } from '../ZalogAuctionDisclaimer';
import { ZalogDisclaimer } from '../ZalogDisclaimer';
import * as styles from './Description.css';

export interface IDescriptionProps {
  description: string | null;
  bank?: string | null;
  auction: boolean;
  isNewbuilding: boolean;
  agentLists: string[];
}

const ElementDescription = WithCollapse({
  WrappedComponent: Children,
});

export class Description extends React.PureComponent<IDescriptionProps> {
  public render() {
    const { bank, auction, isNewbuilding, agentLists } = this.props;

    const shouldShowBankDisclaiemr = Boolean(bank || agentLists.includes('pledgeRealty'));
    const shouldShowAuctionDisclaimer = Boolean(auction || agentLists.includes('tradeRealty'));
    const shouldShowElectronicTradeDisclaimer = agentLists.includes('electronTradeSite');
    const shouldShowEncumbranceDisclaimer = agentLists.includes('encumbranceRealty');

    return (
      <div id="description">
        <div className={styles['description-container']}>
          <ElementDescription
            isNewbuilding={isNewbuilding}
            blockType={ECollapseBlockType.FlatDescription}
            header="Описание квартиры"
            headerClassName={styles['description-header']}
          >
            <>
              <div className={styles['description-parts']}>
                <div>{this.renderDescription()}</div>
              </div>
              {shouldShowBankDisclaiemr && (
                <div data-testid="description-parts_bank" className={styles['description-parts']}>
                  {' '}
                  <ZalogDisclaimer />{' '}
                </div>
              )}
              {shouldShowAuctionDisclaimer && (
                <div data-testid="description-parts_auction" className={styles['description-parts']}>
                  {' '}
                  <ZalogAuctionDisclaimer />{' '}
                </div>
              )}
              {shouldShowElectronicTradeDisclaimer && (
                <div data-testid="description-parts_electronic_trade" className={styles['description-parts']}>
                  {' '}
                  <ElectronicTradeDisclaimer />{' '}
                </div>
              )}
              {shouldShowEncumbranceDisclaimer && (
                <div data-testid="description-parts_encumbrance_realty" className={styles['description-parts']}>
                  {' '}
                  <EncumbranceDisclaimer />{' '}
                </div>
              )}
            </>
          </ElementDescription>
        </div>
      </div>
    );
  }

  private renderDescription = () => {
    const { description } = this.props;

    if (!description) {
      return null;
    }

    const desc = (
      <span>
        <p {...{ itemProp: 'description' }} className={styles['description-text']}>
          {description}
        </p>
      </span>
    );

    return desc;
  };
}
